(function() {
  'use strict';
  angular.module('common')
  .service('historyService',function() {
    var claimHistories = [];
    var claimsSearchHistories = [];
    var benefitHistories = [];
    let claimsEftSearchHistories = [];
    let claimsCheckNumSearchHistories = [];
    let claimsDateRangeSearchHistories = [];
    return {
      claimHistories,
      claimsSearchHistories,
      benefitHistories,
      claimsEftSearchHistories,
      claimsCheckNumSearchHistories,
      claimsDateRangeSearchHistories
    };
  });
})();
